import { IFieldProps } from 'Components/Core/Field/types';
import { Severity } from 'Data/ViewModels/Core/Severity';
import { hasNonEmptyValue } from 'Lib/Any';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../Lib/Object/deepEquals';
import { Field, TextOutput } from '../../Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { createLimitSelector } from './Helpers/limitHelpers';
import { IWorksheetComponent } from './types';

// Component that outputs a TextOutput Field containing
// the text of the limit for the given path

// TODO: Can probably be achieved with the same injected limit Field uses.

interface ILimitTextFieldProps {
  path: string;
}

let LimitTextField: React.FC<ILimitTextFieldProps & IWorksheetComponent & Omit<IFieldProps, 'input' | 'value'>> = ({
  path,
  createWorksheetSelector,
  ...props
}) => {
  const limit = useSelector(createLimitSelector(createWorksheetSelector!, path), deepEquals);
  let severity: Severity;
  if (hasNonEmptyValue(limit)) severity = limit.IsPassing ?? true ? 'info' : 'error';

  return (
    <Field input={<TextOutput />} value={limit?.Text} severity={severity} blankReplacement={undefined} {...props} />
  );
};

LimitTextField = withInjectedProps(LimitTextField);
export { LimitTextField };
